<ggc-theme-selector
  [themes]="themes"
  [showActiveCounters]="showActiveCounters"
  [iconCollapsed]="iconCollapsed"
  [iconExpanded]="iconExpanded"
  [iconAlignRight]="iconAlignRight"
  [iconDisabled]="iconDisabled"
  [iconChecked]="iconChecked"
  [iconUnchecked]="iconUnchecked"
  [iconInfoUrl]="iconInfoUrl"
  [hideTree]="hideTree"
  [layerLabelComponent]="layerLabelComponent"
  [datasetLabelComponent]="datasetLabelComponent"
  [expandTreeOnInit]="expandTreeOnInit"
  [showOnlyDatasets]="showOnlyDatasets"
  [layerEnabledCallback]="layerEnabledCallback"
  [mapIndex]="mapIndex"
  [viewerType]="viewerType"
>
</ggc-theme-selector>
